// ptw-cart-refresh.js — robust cart drawer content refresh.
//
// Every time the cart drawer opens (any path), re-fetch the current header
// section HTML and swap the drawer's inner content + the cart count bubble.
// Also hooks after /cart/add.js and pageshow (bfcache).
(function () {
  if (window.__ptwCartRefreshInit) return;
  window.__ptwCartRefreshInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var inflight = null;
  var busy = false;

  function qs(sel, root) { return (root || document).querySelector(sel); }

  function getSectionId() {
    // The <cart-items-component data-section-id="…"> is what Horizon uses to
    // morph the drawer. Reuse the same id for the Section Rendering API.
    var el = qs('cart-items-component[data-section-id]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function setLoading(on) {
    var items = qs('.cart-drawer__dialog .cart-drawer__items') ||
                qs('.cart-drawer__dialog cart-items-component');
    if (!items) return;
    if (on) {
      items.style.transition = 'opacity 150ms ease';
      items.style.opacity = '0.5';
    } else {
      items.style.opacity = '';
    }
  }

  function swapNode(oldEl, newEl) {
    if (!oldEl || !newEl) return;
    oldEl.replaceWith(newEl);
  }

  function updateDocumentCartState(newDoc) {
    // 1. Swap the drawer's inner content, preserving <cart-drawer-component>
    //    and the <dialog> wrapper (so open/close mechanics stay intact).
    var newInner = qs('.cart-drawer__inner', newDoc);
    var oldInner = qs('.cart-drawer__inner');
    if (newInner && oldInner) {
      oldInner.innerHTML = newInner.innerHTML;
      // Also mirror the empty/filled class on the dialog
      var newDialog = qs('.cart-drawer__dialog', newDoc);
      var oldDialog = qs('.cart-drawer__dialog');
      if (newDialog && oldDialog) {
        oldDialog.classList.toggle('cart-drawer--empty', newDialog.classList.contains('cart-drawer--empty'));
      }
    }

    // 2. Swap the cart bubble (count badge next to the icon).
    var sels = [
      '[ref="cartBubble"]',
      '.header-actions__cart-icon .cart-bubble',
      '.cart-bubble',
    ];
    for (var i = 0; i < sels.length; i++) {
      var oldB = qs(sels[i]);
      var newB = qs(sels[i], newDoc);
      if (oldB && newB) {
        swapNode(oldB, newB.cloneNode(true));
        break;
      }
    }
    // 3. Mirror the icon class that marks has-cart / no-cart.
    var newIcon = qs('.header-actions__cart-icon', newDoc) || qs('cart-icon-component', newDoc);
    var oldIcon = qs('.header-actions__cart-icon') || qs('cart-icon-component');
    if (newIcon && oldIcon) {
      oldIcon.classList.toggle('header-actions__cart-icon--has-cart', newIcon.classList.contains('header-actions__cart-icon--has-cart'));
    }
  }

  async function ptwRefreshCart() {
    if (busy) return inflight;
    var sectionId = getSectionId();
    if (!sectionId) return null;
    busy = true;
    setLoading(true);
    inflight = (async function () {
      try {
        var url = ROOT.replace(/\/$/, '') + '/?sections=' + encodeURIComponent(sectionId);
        var r = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          cache: 'no-store',
        });
        if (!r.ok) return;
        var data = await r.json();
        var html = data[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        updateDocumentCartState(doc);
      } catch (e) {
        // swallow — leave the drawer with whatever it had rather than crash
      } finally {
        setLoading(false);
        busy = false;
      }
    })();
    return inflight;
  }

  // Public hook so other scripts can trigger a refresh if needed.
  window.ptwRefreshCart = ptwRefreshCart;

  // ====== triggers ======

  // (a) Any drawer open → refresh. Native <dialog> toggles the `open`
  //     attribute when showModal() runs, so a MutationObserver on it
  //     catches every open regardless of trigger (icon, auto-open after add,
  //     mobile sticky ADD, etc.).
  function hookDialog() {
    var dialog = qs('dialog.cart-drawer__dialog');
    if (!dialog) return false;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'open' && dialog.hasAttribute('open')) {
          ptwRefreshCart();
          break;
        }
      }
    });
    mo.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    return true;
  }

  // (b) After any cart add/update event. CartAddEvent extends cart:update,
  //     so one listener catches both.
  document.addEventListener('cart:update', function () {
    // Horizon's cart-items-component morphs itself from the response sections,
    // but external pieces (count bubble, cart drawer header, free-shipping
    // bar) may still show stale data. Refresh to be safe.
    ptwRefreshCart();
  });

  // (c) Back/forward cache restore.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) ptwRefreshCart();
  });

  if (document.readyState !== 'loading') {
    hookDialog();
  } else {
    document.addEventListener('DOMContentLoaded', hookDialog);
  }
})();
